'use client';

import { ProfileTypes } from '@/constants/profileType.constant';
import useStore from '@/stores/store';
// import { CommunityRoles } from '@/utils/communityRoles';
import { useEffect, useState } from 'react';

const useUser = () => {
  return useStore((state) => state.user);
};

const useUserRole = () => {
  return useStore((state) => state.user.role);
};

const useIsCommunityAdmin = () => {
  return useStore(
    (state) => state.user.isCompanyAdmin || state.user.isNonProfitAdmin,
  );
};

const useIsCompanyAdmin = () => {
  return useStore((state) => state.user.isCompanyAdmin);
};

const useIsNonProfitAdmin = () => {
  return useStore((state) => state.user.isNonProfitAdmin);
};

const useIsCompanyAdminFor = (companyId) => {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    const user = useStore.getState().user;
    if (user.isCompanyAdmin) {
      setIsAdmin(user.profile.activeCommunity?.id === companyId);
    } else {
      setIsAdmin(false);
    }
  }, [companyId]);
  return isAdmin;
};

const useIsNonProfitAdminFor = (nonProfitId) => {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    const user = useStore.getState().user;
    if (user.isNonProfitAdmin) {
      setIsAdmin(user.profile.activeCommunity?.nonProfit?.id === nonProfitId);
    } else {
      setIsAdmin(false);
    }
  }, [nonProfitId]);
  return isAdmin;
};

const useIsNonProfitUser = () => {
  return useStore((state) => state.user.isNonProfitUser);
};

const useIsCompanyUser = () => {
  return useStore((state) => state.user.isCompanyUser);
};

const useIsNekiAdmin = () => {
  return useStore((state) => state.user.isNekiAdmin);
};

const useProfileType = () => {
  const isNonProfitAdmin = useIsNonProfitAdmin();
  if (isNonProfitAdmin) {
    return ProfileTypes.Organization;
  }
  return ProfileTypes.Individual;
};

export {
  useUser,
  useUserRole,
  useIsCompanyAdmin,
  useIsNonProfitAdmin,
  useIsNonProfitUser,
  useIsCompanyUser,
  useIsNekiAdmin,
  useProfileType,
  useIsNonProfitAdminFor,
  useIsCompanyAdminFor,
  useIsCommunityAdmin,
};
